import { Text } from "@mobi/ds"
import { Fragment } from "react"
import TokenList from "./components/TokenList"
import "./TokenGallery.scss"
import itau from "@mobi/ds/tokens/itau"
import iti from "../../ds-iti/tokens/iti"

const allTokens = {
  itau,
  iti,
}

const TokenGallery = ({ app }) => {
  const tokens = allTokens[app]
  return (
    <div className="token-gallery">
      <Text as="h1" className="token-gallery_title">
        {`Galeria de tokens - DS (${app})`}
      </Text>
      <Text as="p" className="token-gallery__info">
        Essa galeria apresenta todos os tokens adicionados nos arquivos{" "}
        <strong>border, colors, media-query, spacing, typography</strong> e{" "}
        <strong>variant</strong>.
      </Text>
      <Text as="p" className="token-gallery__info">
        Para copiar o <em>css var</em> de um token basta clicar sobre o card do
        token desejado
      </Text>

      {Object.keys(tokens).map((token) => {
        return (
          <Fragment key={token}>
            <div className="token-gallery__divider">
              <Text as="h2" className="token-gallery__subtitle">
                {token}
              </Text>
            </div>
            <TokenList tokens={tokens[token]} />
          </Fragment>
        )
      })}
    </div>
  )
}

export default TokenGallery
